export const AUTHENTICATION = 'authentication';
export const USERS = 'users';
export const GOALS = 'goals';
export const MEETINGS = 'meetings';
export const GROUPS = 'groups';
export const APP = 'app';
export const ACTIVITIES = 'activities';
